const lmz743 = [
    [
        -87.345618000000002,
        41.715251600000002
    ],
    [
        -87.332816699999995,
        41.709113600000002
    ],
    [
        -87.31941119999999,
        41.707823600000005
    ],
    [
        -87.316200899999984,
        41.707043200000008
    ],
    [
        -87.31276179999999,
        41.706685100000009
    ],
    [
        -87.358411999999987,
        41.628187200000006
    ],
    [
        -87.365440299999989,
        41.629535600000004
    ],
    [
        -87.374838999999994,
        41.631735900000002
    ],
    [
        -87.399543699999995,
        41.6386337
    ],
    [
        -87.404540999999995,
        41.640533400000002
    ],
    [
        -87.413839899999999,
        41.643035000000005
    ],
    [
        -87.423439000000002,
        41.642833700000004
    ],
    [
        -87.429839999999999,
        41.646034200000003
    ],
    [
        -87.433441099999996,
        41.648933400000004
    ],
    [
        -87.433640799999992,
        41.650733600000002
    ],
    [
        -87.434540999999996,
        41.650535000000005
    ],
    [
        -87.435142499999998,
        41.653335500000004
    ],
    [
        -87.436743300000003,
        41.653933900000006
    ],
    [
        -87.438141000000002,
        41.653335000000006
    ],
    [
        -87.438941900000003,
        41.654335000000003
    ],
    [
        -87.43754100000001,
        41.654735000000002
    ],
    [
        -87.437441000000007,
        41.655335000000001
    ],
    [
        -87.434341900000007,
        41.656334700000002
    ],
    [
        -87.435740900000013,
        41.658535000000001
    ],
    [
        -87.433841000000015,
        41.658435900000001
    ],
    [
        -87.433944700000012,
        41.659435199999997
    ],
    [
        -87.429241000000019,
        41.663734999999996
    ],
    [
        -87.427841100000023,
        41.663535999999993
    ],
    [
        -87.424041000000017,
        41.665734999999991
    ],
    [
        -87.42084100000001,
        41.667934999999993
    ],
    [
        -87.418741000000011,
        41.670234999999991
    ],
    [
        -87.418941000000018,
        41.671834999999994
    ],
    [
        -87.417841000000024,
        41.673134999999995
    ],
    [
        -87.416839500000023,
        41.671836799999994
    ],
    [
        -87.41763960000003,
        41.671333899999993
    ],
    [
        -87.417138000000023,
        41.670937299999991
    ],
    [
        -87.415241000000023,
        41.672434999999993
    ],
    [
        -87.428443900000019,
        41.68153379999999
    ],
    [
        -87.434441000000021,
        41.682734999999987
    ],
    [
        -87.435539200000022,
        41.682533199999988
    ],
    [
        -87.441224800000029,
        41.679142399999989
    ],
    [
        -87.434738100000033,
        41.682136499999991
    ],
    [
        -87.429039000000031,
        41.68093489999999
    ],
    [
        -87.427741000000026,
        41.680134999999993
    ],
    [
        -87.443054100000026,
        41.667652099999991
    ],
    [
        -87.449541000000025,
        41.673234999999991
    ],
    [
        -87.453041000000027,
        41.673034599999994
    ],
    [
        -87.455841000000021,
        41.673633499999994
    ],
    [
        -87.45414390000002,
        41.673634999999997
    ],
    [
        -87.458642000000026,
        41.675134999999997
    ],
    [
        -87.462456000000032,
        41.676913999999996
    ],
    [
        -87.46280670000003,
        41.676738699999994
    ],
    [
        -87.46314230000003,
        41.675533199999997
    ],
    [
        -87.47074200000003,
        41.672834999999999
    ],
    [
        -87.471740700000026,
        41.673133800000002
    ],
    [
        -87.475944500000026,
        41.675033500000005
    ],
    [
        -87.48114200000002,
        41.678635000000007
    ],
    [
        -87.485942000000023,
        41.680635000000009
    ],
    [
        -87.485145500000016,
        41.682834600000007
    ],
    [
        -87.490844700000011,
        41.684234600000003
    ],
    [
        -87.501045200000007,
        41.689033500000001
    ],
    [
        -87.505343000000011,
        41.691535000000002
    ],
    [
        -87.508941600000014,
        41.694133700000002
    ],
    [
        -87.511043000000015,
        41.696535000000004
    ],
    [
        -87.51654400000001,
        41.703335000000003
    ],
    [
        -87.515243500000011,
        41.704235000000004
    ],
    [
        -87.520545600000005,
        41.709933900000003
    ],
    [
        -87.52334590000001,
        41.708133600000004
    ],
    [
        -87.524044000000004,
        41.708335000000005
    ],
    [
        -87.526831000000001,
        41.709773000000006
    ],
    [
        -87.527633600000001,
        41.710773400000008
    ],
    [
        -87.526230999999996,
        41.71227300000001
    ],
    [
        -87.528230999999991,
        41.715173000000007
    ],
    [
        -87.524230899999992,
        41.717273600000006
    ],
    [
        -87.524216899999999,
        41.718354000000005
    ],
    [
        -87.524917599999995,
        41.719543400000006
    ],
    [
        -87.525041999999999,
        41.720424000000008
    ],
    [
        -87.524993999999992,
        41.721440000000008
    ],
    [
        -87.524713999999989,
        41.721980000000009
    ],
    [
        -87.524162199999992,
        41.722438800000006
    ],
    [
        -87.524140999999986,
        41.723990000000008
    ],
    [
        -87.525040999999987,
        41.725090000000009
    ],
    [
        -87.529509799999985,
        41.732304400000011
    ],
    [
        -87.525600399999988,
        41.733090900000008
    ],
    [
        -87.405039699999989,
        41.761046500000006
    ],
    [
        -87.396572099999986,
        41.758473100000003
    ],
    [
        -87.381038699999991,
        41.750004800000006
    ],
    [
        -87.367006199999992,
        41.740320900000007
    ],
    [
        -87.356355099999988,
        41.731320800000006
    ],
    [
        -87.345618000000002,
        41.715251600000002
    ]
];

export default lmz743;
